<template>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <b-container>
        <!-- <div style="font-size: 30px; text-align: center; padding: 20px; margin: auto">
          {{ user.name}} {{ user.surname }}
        </div> -->
        <b-form @submit.prevent="onUpdateForm">
          <div>
            <b-input-group prepend="Nome & Cognome" size="7" class="my-4">
              <b-form-input aria-label="first name" class="mx-3" v-model="user.name" placeholder="nome" required></b-form-input>
              <b-form-input aria-label="last name" v-model="user.surname" placeholder="cognome" required></b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-input-group prepend="email" size="7" class="my-4">
              <b-form-input aria-label="email" class="ml-3" v-model="user.email" placeholder="email" required></b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-input-group prepend="Cellulare" class="mb-4">
              <b-form-input aria-label="prefix" class="mx-3" v-model="user.phone_prefix" placeholder="prefisso internazionale" required></b-form-input>
              <b-form-input aria-label="mobile nr" v-model="user.phone_nr" placeholder="nr cellulare" required></b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-input-group prepend="Indirizzo" class="mb-4">
              <b-form-input aria-label="address" class="ml-3" v-model="user.address" placeholder="indirizzo (via, ...)" required></b-form-input>
              <b-form-input aria-label="cap" class="ml-3" v-model="user.postal_code" placeholder="cap" required></b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-input-group prepend="" class="mb-4">
              <b-form-input aria-label="city" style="margin-left: 104px;" v-model="user.city" placeholder="città" required></b-form-input>
              <b-form-input aria-label="province" class="ml-3" v-model="user.province" placeholder="provincia" required></b-form-input>
              <b-form-input aria-label="country" class="ml-3" v-model="user.country" placeholder="nazione" required></b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-input-group prepend="Documento" class="mb-4">
              <template>
                <b-form-select aria-label="doc_type" class="mx-3" v-model="selectedDocType"  :options="docTypes" placeholder="tipo documento" required>
                  <option v-for="(text, value) in docTypes" 
                    :key="value"
                    :value="text">
                  </option>
                </b-form-select>
              </template>
              <b-form-input aria-label="id nr" v-model="user.doc_nr" placeholder="nr documento" required></b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-input-group prepend="Reset Password" class="mb-4">
              <template>
                <b-form-select aria-label="reset_pwd" class="mx-3" v-model="selectedResetPwd"  :options="resetPwdOptions" required>
                  <option v-for="(text, value) in resetPwdOptions" 
                    :key="value"
                    :value="text">
                  </option>
                </b-form-select>
              </template>
              <b-form-input v-if="selectedResetPwd" aria-label="pwd" v-model="user.password" placeholder="password" required></b-form-input>
            </b-input-group>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-block">SALVA</button>
          </div>
        </b-form>

        <b-modal ref="my-modal" centered hide-footer title="Utente AGGIORNATO">
          <div class="d-block text-center">
             <h3>User <strong>{{ user.name }} {{ user.surname }}</strong> aggiornato.
             </h3>
          </div>
          <b-button class="mt-2" variant="outline-success" block @click="hideModal">
             CHIUDI
          </b-button>
       </b-modal>
      </b-container>
    </div>
  </div>
</template>

<script>
  import { db, firebaseApp } from '../../firebase/config.js';
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    data() {
      return {
        user: {
          name: '',
          surname: '',
          email: '',
          resetPwd: false,
          password: '',
          phone_prefix: '', // this.auth_user.data.storeDefaults.phonePrefix | '',
          phone_nr: '',
          address: '',
          postal_code: '',
          city: '', // this.auth_user.data.storeDefaults.city | '',
          province: '', // this.auth_user.data.storeDefaults.province | '',
          country: '', // this.auth_user.data.storeDefaults.country | '',
          doc_type: ''
        },
        docTypes: [
          { value: null, text: 'Seleziona tipo documento' },
          { value: 'ci', text: 'Carta Identità'},
          { value: 'pat.', text: 'Patente' },
          { value: 'pass', text: 'Passaporto' },
        ],
        selectedDocType: '',
        resetPwdOptions: [
          { value: true, text: 'SI'},
          { value: false, text: 'NO'},
        ],
        selectedResetPwd: false,
        error: {
           value: null,
           message: ''
        },
        success: {
           value: null,
           message: ''
        },
      }
    },
    created() {
      let dbRef = db.collection('users').doc(this.sel_user.data.id);
      dbRef.get().then((doc) => {
        this.user = {...doc.data()};
        this.selectedDocType = this.user.doc_type
      }).catch((error) => {
        console.log(error)
      })
    },
    computed: {
      ...mapGetters({
        // map `this.sel_user` to `this.$store.getters._user`
        auth_user: "user",
        sel_user: "_user",
        // map `this.sel_dog` to `this.$store.getters._dog`
        sel_dog: "_dog",
        sel_subs: "_subs",
        sel_card: "_card",
      }),
    },
    mounted() {
       this.$root.$on('bv::modal::ok', (bvModalEvt) => {
          console.log('Modal closed', bvModalEvt)
       })
    },
    methods: {
      showModal() {
        this.$refs['my-modal'].show()
      },
      hideModal() {
        console.log('aggiornamento USER')
        this.$refs['my-modal'].hide()
        this.$router.push({name:'user_detail'})
      },
      /*toggleModal() {
         // We pass the ID of the button that we want to return focus to
         // when the modal has hidden
         this.$refs['my-modal'].toggle('#toggle-btn')
      },*/
      onUpdateForm(event) {
        event.preventDefault()
        this.user.uid = this.sel_user.data.id
        this.user.displayName = this.user.name + ' ' + this.user.surname
        this.user.fullName = this.user.surname + ' ' + this.user.name
        this.user.doc_type = this.selectedDocType
        this.user.resetPwd = this.selectedResetPwd
        console.log('editMode - user:', this.user)
        const setUser = firebaseApp
        .functions('europe-west3')
        .httpsCallable('setUser');

        setUser(this.user)
        .then((resp) => {
          //Save user data returned by API function on VUEX Store
          //console.log(resp.data.result);
          console.log(resp)
          console.log(resp.data.result.userId);
          console.log(resp.data.result.displayName);
          this.set_sel_user({
            id: resp.data.result.userId,
            fullName: resp.data.result.fullName,
            displayName: resp.data.result.displayName,
          })
          console.log("USER aggiornato!");
          this.showModal();
        })
        .catch((error) => {
          console.log(error);
        })
      },
      ...mapMutations({
        set_sel_user: 'SET_SEL_USER', // map `this.set_sel_user()` to `this.$store.commit('SET_SEL_USER')`
        set_sel_dog: 'SET_SEL_DOG'
      })
    },
  };
</script>